export default [
  {
    path: '/benefits/benefitsList',
    name: 'BENEFITSLIST',
    component: () => import('@/views/benefits/benefitsList'),
    meta: {
      title: '权益中心'
    }
  },
  {
    path: '/benefits/benefitsDetail',
    name: 'BENEFITSDETAIL',
    component: () => import('@/views/benefits/benefitsDetail'),
    meta: {
      title: '权益详情'
    }
  },
  {
    path: '/benefits/benefits-process',
    name: 'BENEFITSPROCESS',
    component: () => import('@/views/benefits/weimai/benefits-process'),
    meta: {
      // title: '服务流程'
    }
  },
  {
    path: '/benefits/consult-info',
    name: 'CONSULTINFO',
    component: () => import('@/views/benefits/weimai/consult-info'),
    meta: {
      title: '就诊人选择'
    }
  },
  {
    path: '/zhongkang/benefits-process',
    name: 'ZKBENEFITSPROCESS',
    component: () => import('@/views/benefits/zhongkang/benefits-process'),
    meta: {
      title: '在线医保服务'
    }
  },
  {
    path: '/benefits/group', // 组合权益
    name: 'BENEFITSGROUP',
    component: () => import('@/views/benefits/group/index'),
    meta: {
      title: '微医医疗服务'
    }
  },
  {
    path: '/benefits/group/detail', // 组合权益下 单个权益详情介绍页
    name: 'BENEFITSINTRODUCE',
    component: () => import('@/views/benefits/group/detail')
  },
  {
    path: '/benefits/detail', // 权益详情介绍页
    name: 'BENEFITSDETAILINFO',
    component: () => import('@/views/benefits/detail')
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/benefits.js